// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iframe[data-v-0ba00655],.iframe iframe[data-v-0ba00655]{width:100%;height:100%}.iframe iframe[data-v-0ba00655]{border-width:0}", ""]);
// Exports
module.exports = exports;
